















import {Component, Prop, Vue} from 'vue-property-decorator';
import TimeLineItem from "@/components/classBuilder/TimeLineItem.vue";

@Component({
  components: {
    TimeLineItem
  },
})
export default class TimeLine extends Vue {
  @Prop()
  private title!: string;

  @Prop({default: true})
  private isExercise!: boolean;

  @Prop({default:[]})
  private items?: Array<any>;
}
